import { useEffect, useState } from "react";
import { notify } from "../../utils/utils";
import { AuthFetch, AuthFetchTGUIO } from "../../services/api";
import { useModal } from "../useModal";

export const useUsers= () => {
    const usuarioDefault = {
        uid : '',
        nombreCompleto: '',
        userPassword: '',
        role: '',
        createdDate:'',
    }
    const [ usuarios, setUsuarios ] = useState([]);
    const [ usuario, setUsuario ] = useState(usuarioDefault);
    const [ isOpenModalRegistrar, openModalRegistrar, closeModalRegistrar ] = useModal(null);
    const [ roles, setRoles ] = useState([]);
    const [ usuariosSinSala, setUsuariosSinSala ] = useState([]);
    const [ loading, setLoading ] = useState(false);

    const listarUsuariosPlataforma = async () => {
        setLoading(true)
        try
        {
            const response = await AuthFetchTGUIO('/users/ldap/groups');
            if(response.isValid){
                const nuevaData = await Promise.all(response.content.map(async (data) => {
                    return {...data, role: data.role.join(',')}
                }))
                setUsuarios(nuevaData);
            }
            else{
                setUsuarios([]);
            }
        }
        catch(error)
        {
            setUsuarios([]);
            notify('Ocurrió un error en el servicio','error');
            console.log('Error al listar ',error);
        }
        setLoading(false);
    }

    const listarRoles = async () => {
        try{
            const response = await AuthFetchTGUIO('/users/ldap/roles');
            if(response.isValid){
                setRoles(response.content);
            }
            else{
                setRoles([]);
            }
        }
        catch(error){
            setRoles([]);
            notify('Ocurrió un error en el servicio','error');
            console.log('Error al listar ',error)
        }
    }
    
    const obtenerDatosUsuario = async (data) => {
        if(data){
            editarValorUsuario("uid",data.uid);
            editarValorUsuario("nombreCompleto",data.givenName + ' '  + data.apellidoPaterno + ' ' + data.apellidoMaterno);
            editarValorUsuario("userPassword",data.userPassword||'');
            editarValorUsuario("createdDate",data.createdDate);
            editarValorUsuario("role",data.role);
        }
        else{
            setUsuario(usuarioDefault)
        }
    }

    const guardarEditarUsuariosPlataforma = async () => {
        if(usuario.nombreCompleto.split(' ').length < 3){
            notify('El nombre debe estar compuesto por mínimo un nombre y dos apellidos','error');
            return;
        }
        if(usuario.role.split(',').length === 0){
            notify('Seleccione como mínimo un rol','error');
            return;
        }

        try
        {
            const esGuardar = usuario.createdDate === '' ? true : false;
            const largo = (usuario.nombreCompleto).split(' ').length
            const response = await AuthFetchTGUIO('/users/ldapWeb',{
                method: esGuardar ? 'POST' : 'PUT' ,
                body: JSON.stringify({
                    uid: usuario.uid,
                    givenName: largo === 3 ? usuario.nombreCompleto.split(' ')[0] : usuario.nombreCompleto.split(' ').slice(0, -2).join(' ') ,
                    apellidoPaterno:  usuario.nombreCompleto.split(' ')[(largo-1)-1],
                    apellidoMaterno: usuario.nombreCompleto.split(' ')[(largo-1)],
                    role: usuario?.role?.split(',').length === 1 ? [usuario.role] : usuario.role.split(','),
                    userPassword: usuario.userPassword,
                }),
            });
            notify( response.isValid ? response.content : response.exceptions[0].description, response.isValid ? 'success' : 'error');
            return response.isValid;

        }
        catch(error)
        {
            console.log('error al guardar ',error);
            notify('Ocurrió un error en el servicio','error');
        }
    }

    const eliminarUsuarioPlataforma = async () => {
        try
        {
            const response = await AuthFetch('/chat-groups',{
                method: 'DELETE',
                body: JSON.stringify({
                }),
            });
            notify(response.content, response.isValid ? 'success' : 'error');
        }
        catch(error)
        {
            console.log('error al eliminar ',error);
            notify('Ocurrió un error en el servicio','error');
        }
    }

    const editarValorUsuario = (key, value) => {
        setUsuario(usuario => {
            return {
                ...usuario,
                [key]: value
            }
        });
    }

    const listarUsuariosSinSalaChat = async () => {
        try{
            const response = await AuthFetchTGUIO('/users/ldap/whitout/groups')
            if(response.isValid){
                setUsuariosSinSala(response.content);
            }
            else{
                notify(response.exceptions[0].description, 'error');
                setUsuariosSinSala([]);
            }
        }
        catch(error){
            setUsuariosSinSala([]);
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al listar -> ',error)
        }
    } 

    

    return{
        setUsuario,
        usuario,
        usuarios,
        listarUsuariosPlataforma,
        obtenerDatosUsuario,
        guardarEditarUsuariosPlataforma,
        eliminarUsuarioPlataforma,
        editarValorUsuario,
        isOpenModalRegistrar,
        openModalRegistrar,
        closeModalRegistrar,
        roles,
        listarRoles,
        listarUsuariosSinSalaChat,
        usuariosSinSala,
        loading
    }
}   